import React, { useState, useEffect, useMemo } from "react";
import { useRecoilState } from "recoil";
import { useHistory, useLocation } from "react-router-dom";
import { providerState } from "../../recoil/atoms";
import {
  GetHeaderMenuLinks,
  GetLoginHeader,
  GetMobileActionLinks,
} from "../Header/HeaderMenuLinks";
import {
  MobileMenuHr,
  MobileMenuLinkHrContainer,
  MenuContainer,
} from "./MobileMenu.styles";
import { LOGIN_PAGE_URL } from "../../utils/urlConstants";
import { useAuthenticationHook } from "../../utils/hooks/useAuthenticationHook";

export const MobileMenu: React.FC<{
  handleToggle: () => void;
  onOpenFeedback?: () => void;
  onToggleHelpPanel?: () => void;
  isHelpPanelOpen?: boolean;
}> = ({
  handleToggle,
  onOpenFeedback,
  onToggleHelpPanel,
  isHelpPanelOpen = false,
}) => {
  const [activeHeader, setActiveHeader] = useState("");
  const [, setProviderInfo] = useRecoilState(providerState);
  const { pathname } = useLocation();
  const history = useHistory();

  useEffect(() => {
    setActiveHeader(pathname);
  }, []);

  const setPathnameCheck = () => {
    setActiveHeader(history.location.pathname);
  };

  useEffect(() => {
    const unlisten = history.listen(() => {
      setPathnameCheck();
    });
    return () => {
      unlisten();
    };
  }, []);

  const { auth } = useAuthenticationHook();

  const headerLinks = useMemo(() => {
    if (!auth?.token) {
      return GetLoginHeader(
        "greyMedium",
        "medium",
        setProviderInfo,
        pathname === LOGIN_PAGE_URL,
      );
    }

    const links = GetHeaderMenuLinks(
      "white",
      "xlarge",
      activeHeader,
      setActiveHeader,
      {
        onToggleHelpPanel,
        isHelpPanelOpen,
        includeHelpLink: Boolean(onToggleHelpPanel),
      },
    );
    const helpLink = links.find((link) => link.key === "help");

    if (!helpLink) return links;

    return [...links.filter((link) => link.key !== "help"), helpLink];
  }, [pathname, auth?.token, activeHeader, onToggleHelpPanel, isHelpPanelOpen]);

  const menuLinks = useMemo(
    () =>
      onOpenFeedback
        ? [...headerLinks, ...GetMobileActionLinks(onOpenFeedback)]
        : headerLinks,
    [headerLinks, onOpenFeedback],
  );

  const headerLinksWithHr = menuLinks.map((headerLink) => (
    <MobileMenuLinkHrContainer key={headerLink.key}>
      {headerLink.header}
      <MobileMenuHr />
    </MobileMenuLinkHrContainer>
  ));

  return (
    <MenuContainer onClick={handleToggle}>
      <br />
      {headerLinksWithHr}
    </MenuContainer>
  );
};
